<template>
    <vs-table :params="params"></vs-table>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";

export default {
  name: "features",
  created: () => {},
  components: {
    VsTable
  },
  data: () => {
    return {
      params: {
        entity: "features",
        list: [],
        headers: {
          featureName: {
            title: "عنوان ویژگی",
            type: "text"
          },
          featureTypeName: {
            title: "نوع ویژگی",
            type: "text"
          },
          features: {
            title: "لیست ویژگی ها",
            type: "custom",
            component: "vs-select",
            multiple: true,
            label: "featureName"
          }
        }
      }
    };
  },
  beforeMount() {},
  methods: {}
};
</script>